import React, { Component } from "react";
import "../../App.css";

const FEATURES = [
    { title: "Auto exits", description: "Stoploss & target fire the moment an entry fills." },
    { title: "One-cancels-other", description: "The other leg cancels itself when one fires." },
    { title: "Force square-off", description: "Auto-exits a position near market close." },
    { title: "GTT triggers", description: "GTT-based orders, managed per symbol." },
    { title: "Margin alerts", description: "Slack ping when funds run low." },
    { title: "Price alerts", description: "Custom per-symbol rules, with trigger history." },
    { title: "Mutual funds", description: "Auto GTT-based buy/sell, plus SIPs." },
    { title: "Watchlist", description: "Live symbol tracking, always synced." },
    { title: "Momentum sell", description: "Raises the ask as price builds — tuned per symbol." },
];

// Recomputed on every render (i.e. every page load) off today's date, so the age/day-count
// keep moving forward on their own — nothing here needs a timer or a stored "last updated" value.
const PROJECT_START_DATE = new Date(2020, 5, 8); // Jun 8, 2020

const getProjectAge = () => {
    const now = new Date();
    let years = now.getFullYear() - PROJECT_START_DATE.getFullYear();
    let months = now.getMonth() - PROJECT_START_DATE.getMonth();
    if (now.getDate() < PROJECT_START_DATE.getDate()) {
        months -= 1;
    }
    if (months < 0) {
        years -= 1;
        months += 12;
    }
    const days = Math.floor((now - PROJECT_START_DATE) / (1000 * 60 * 60 * 24));
    return { years, months, days };
};

const getStats = () => {
    const { years, months, days } = getProjectAge();
    return [
        {
            value: `${years} yr ${months} mo`,
            label: `Running since Jun 8, 2020 · ${days.toLocaleString("en-IN")} days`,
        },
        { value: "1000+", label: "Commits shipped" },
        { value: "Pre-COVID", label: "Investing since before the pandemic" },
        { value: "Solo", label: "One developer, built & changed daily" },
    ];
};

class About extends Component {
    render() {
        const stats = getStats();
        return (
            <div>
                <div className="about-hero">
                    <p className="about-tagline">Built to trade on its own — here's what's under the hood.</p>
                </div>

                <div className="about-feature-list">
                    {FEATURES.map(feature => (
                        <div className="about-feature" key={feature.title}>
                            <h4>{feature.title}</h4>
                            <p>{feature.description}</p>
                        </div>
                    ))}
                </div>

                <header>
                    <h3>Stats</h3>
                </header>
                <div className="about-stats">
                    {stats.map(stat => (
                        <div className="about-stat" key={stat.label}>
                            <span className="about-stat-value">{stat.value}</span>
                            <span className="about-stat-label">{stat.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default About;
